module.exports = __webpack_public_path__ + "16aa5ef7c64ba706ac4052329e359194.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/percentage.png
// module id = 2866
// module chunks = 0